module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-regular-400-9efb86976bd53e159166c12365f61e25.woff2";